import { Model as o } from "../../../model.js";
import { centsToNumber as r } from "../../../../../utils.js";
class a extends o {
  constructor(s) {
    super(), this.itemId = s.itemId, this.refItemId = s.refItemId, this.skuCode = s.skuCode, this.name = s.name, this.voucherCode = s.voucherCode, this.quantity = s.quantity, this.subtotal = s.subtotal, this.taxes = s.taxes, this.total = s.total, this.notes = s.notes, this.modifiers = s.modifiers, this.totalItems = s.totalItems, this.combo = s.combo, this.description = s.description;
  }
  getTotal() {
    return r(this.total);
  }
}
export {
  a as TicketItemModel
};
//# sourceMappingURL=ticketItem.model.js.map
